
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"35","height":"27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.41 25.272H2.318c-.728 0-1.318-.59-1.318-1.318V5.5a1.318 1.318 0 011.318-1.318h7.945","stroke":"#465C6A","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","stroke-dasharray":"1 4"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M10.054 7.863a1 1 0 01.72-1.217l16.818-4.32a1 1 0 011.217.72l4.319 16.818a1 1 0 01-.72 1.217L15.59 25.4a1 1 0 01-1.217-.72L10.054 7.863z","stroke":"#465C6A","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    